import { heroEquipment } from "../HeroEquipment";

export const amazonki = {
  heroes: {
    Królowa: {
      id: 0,
      startingEquipment: ["Sztylet", "Włócznia"],
      cost: 60,
      number: 1,
      equipmentList: heroEquipment["Amazonki z Lustrii"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 4, 4, 3, 3, 2, 4, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: [
        "Akrobata",
        "Dowódca",
        "Nienawiść",
        "Ochronne tatuaże",
        "Zabobonny lęk",
        "Zasadzka",
      ],
      exp: 20,
      skills: [0, 1, 2, 4, 5],
    },
    Megiera: {
      id: 1,
      startingEquipment: ["Sztylet", "Kostur"],
      cost: 40,
      number: 1,
      equipmentList: heroEquipment["Amazonki z Lustrii"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: [
        "Akrobata",
        "Guślarstwo",
        "Mag (Kolegia Magii)",
        "Nienawiść",
        "Ochronne tatuaże",
        "Zabobonny lęk",
      ],
      exp: 12,
      skills: [0, 1, 4, 5],
    },
    Memroda: {
      id: 2,
      startingEquipment: ["Sztylet", "Łapacz"],
      cost: 30,
      number: 1,
      equipmentList: heroEquipment["Amazonki z Lustrii"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 4, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: [
        "Akrobata",
        "Handlarz niewolników",
        "Nienawiść",
        "Ochronne tatuaże",
        "Zabobonny lęk",
        "Żertwa",
      ],
      exp: 8,
      skills: [0, 1, 4, 5],
    },
    Służebna: {
      id: 3,
      startingEquipment: ["Sztylet"],
      cost: 20,
      number: 2,
      equipmentList: heroEquipment["Amazonki z Lustrii"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 2, 2, 3, 3, 1, 3, 1, 6],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Akrobata", "Nienawiść", "Ochronne tatuaże", "Zabobonny lęk"],
      exp: 0,
      skills: [0, 1, 4, 5],
    },
    Niewolnik: {
      id: 4,
      startingEquipment: ["Broń improwizowana"],
      cost: 10,
      number: 15,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [4, 2, 2, 3, 3, 1, 3, 1, 2],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Mięso armatnie", "Niewolnik", "Rozmiar rzondzi"],
    },
    Amazonka: {
      id: 5,
      startingEquipment: ["Sztylet"],
      cost: 20,
      number: 15,
      equipmentList: heroEquipment["Amazonki z Lustrii"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: [
        "Akrobata",
        "Chorążowie & sygnaliści",
        "Nienawiść",
        "Ochronne tatuaże",
        "Zabobonny lęk",
      ],
    },
    Mara: {
      id: 6,
      startingEquipment: ["Sztylet", "Włócznia"],
      cost: 45,
      number: 5,
      equipmentList: heroEquipment["Amazonki z Lustrii"].Mara,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 4, 4, 1, 3, 1, 10],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Akrobata", "Fanatyk", "Furia", "Nienawiść", "Ochronne tatuaże"],
    },
    Zmora: {
      id: 7,
      startingEquipment: ["Sztylet", "Łuk"],
      cost: 35,
      number: 5,
      equipmentList: heroEquipment["Amazonki z Lustrii"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 4, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: [
        "Akrobata",
        "Błyskawiczne przeładowanie",
        "Nienawiść",
        "Ochronne tatuaże",
        "Zabobonny lęk",
        "Zasadzka",
        "Zwiadowca",
      ],
    },
    Walkiria: {
      id: 8,
      startingEquipment: [
        "Sztylet",
        "Miecz",
        "Włócznia",
        "Koń bojowy",
        "Siodło & uprząż",
      ],
      cost: 70,
      number: 3,
      equipmentList: heroEquipment["Amazonki z Lustrii"].Walkiria,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
        "Koń bojowy": [8, 3, 0, 3, "-", "-", 3, 1, 5],
      },
      rules: [
        "Akrobata",
        "Kawalerzysta",
        "Lekka jazda",
        "Nienawiść",
        "Ochronne tatuaże",
        "Zabobonny lęk",
        "Zasadzka",
      ],
    },
    Gorgona: {
      id: 9,
      startingEquipment: ["Sztylet", "Włócznia", "Mechaniczne skrzydła"],
      cost: 45,
      number: 3,
      equipmentList: heroEquipment["Amazonki z Lustrii"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Akrobata", "Lot", "Nienawiść", "Ranger", "Zwiadowca"],
    },
    Więźniarka: {
      id: 10,
      startingEquipment: [],
      cost: 175,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        "Powóz": ["-","-","-",4,8,8,"-","-","-"],
        "Koń": [8,3,0,3,3,1,3,1,5],
        "Koń ": [8,3,0,3,3,1,3,1,5]
      },
      rules: ["Duży cel", "Machina wojenna", "Powóz", "Więźniarka"],
    },
    Rydwan: {
      id: 11,
      startingEquipment: [],
      cost: 125,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        "Rydwan": ["-","-","-",5,5,8,"-","-","-"],
        "Koń": [8,3,0,3,3,1,3,1,5],
        "Koń ": [8,3,0,3,3,1,3,1,5]
      },
      rules: ["Duży cel", "Machina wojenna", "Rydwan"],
    },
  },
  limit: 500,
  minModels: 3,
  maxModels: 15,
  name: "Amazonki z Lustrii",
  nature: "Zła",
  armyRules: ["Podatek","Rozrzutność"],
  mercenaries: ["Czarownica", "Magus", "Minstrel", "Szpieg", "Wróżbita"],
};
